/***************************************************************************/
"use client";
/***************************************************************************/

import ConnectionProvider from "@/client/api/connection-provider";

const RootFetchConnectionProvider: React.FC<{
  rootUrl: string;
  consoleLogs?: boolean;
  children: React.ReactNode;
}> = ({ rootUrl, consoleLogs, children }) => {
  return (
    <ConnectionProvider
      rootUrl={rootUrl}
      onBefore={(args) => {
        if (consoleLogs) {
          console.log("onBefore", args);
        }
      }}
      onAfter={(args) => {
        if (consoleLogs) {
          console.log("onAfter", args);
        }
      }}
    >
      {children}
    </ConnectionProvider>
  );
};

export { RootFetchConnectionProvider };
